module.exports = __webpack_public_path__ + "static/cssFallback@2x-b05f1443dd8069747fc0b7847f9dc74d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/features/handoff/cssFallback@2x.jpg
// module id = 2600
// module chunks = 168707334958949